import { environment } from '@env/environment';
import { Component, Output, EventEmitter, OnInit, OnDestroy, HostListener, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from '@app/gateway/services/auth.service';
// import { HttpHeaders } from '@angular/common/http';
import { SigninService } from '@app/gateway/signin/signin.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceConfigService } from '@app/services/service-config.service';
import { CreateAccountService } from '@app/gateway/services/createAccount.service';
import { JoyrideService } from 'ngx-joyride';
import { ChatbotComponent } from '../chatbot/chatbot.component';
import { isNil, and } from 'ramda';
import { ProcessService } from '@app/services/process.service';
import {StateService} from '@app/services/state/state.service';
import { UserProfileService } from "@app/gateway/user-profile/user-profile.service";
import { userTypeUpdated } from '@app/providers/at-a-glance/at-a-glance.component';
import { ModalService } from '@app/services/modal/modal.service';
import { CookieService  } from "ngx-cookie-service";

/* Kore ChatBot */
declare const $: any;
declare var destroy: any;
/* Kore ChatBot */

@Component({
    selector: 'nh-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  region = environment.region;
  gatewayURL = environment.gatewayURL;
  @Output() toggle = new EventEmitter();
  @Output() signin = new EventEmitter();
  @Output() signout = new EventEmitter();
  userSub!: Subscription;
  userDetails: any;
  pPUserDetails;
  tcamId;
  entId;
  pPUserName;
  isLoggedOut = false;
  rtData;
  dropdownOpened = false;
  hovered = false;
  profileOptions = [
    { value: 'Manage My Account', link: '/user-profile/manage-account'},
    { value: 'Communication Preferences', link: '/user-profile/communication-preferences'},
  ];
  defaultLanguage;
  currentLang = sessionStorage.getItem('currentLang') ? sessionStorage.getItem('currentLang') : 'en';
  globalLanguage;
  userType;
  showTutorialInMobileView = false;
  screenHeight: number;
  screenWidth: number;
  isMobileView = false;
  mobileWidth = 480;
  indivId: any;
  isKepro: any;
  show = true;
  agentRequested = false;
  url:string;
  tcamKey:string;
  awsTranslateSwitch = false;
  queryUserType: string | null = null;

  constructor(
    private state: StateService,
    private router: Router,
    private singInService: SigninService,
    private translate: TranslateService,
    private authService: AuthService,
    // private apiService: ApiService,
    private createAccountService: CreateAccountService,
    private activatedRoute: ActivatedRoute,
    private serverConfig: ServiceConfigService,
    public readonly joyrideService: JoyrideService,
    public processService: ProcessService,
    private userProfileService: UserProfileService,
    private modal: ModalService,
    private cookieService: CookieService,
    private cd: ChangeDetectorRef
    ) {
    this.getScreenSize();
    this.processService.getOnLogout().subscribe(res => {
      this.removeSignIn(res)
    });
  }

  @HostListener("window:resize")
  getScreenSize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
  }

  ngOnInit() {
    this.tcamKey = this.serverConfig.getServerConfig().TCAM_KEY;
    this.awsTranslateSwitch = this.serverConfig.getServerConfig().awsTranslateSwitch;
    this.singInService.accountData.subscribe(res => {
      this.indivId = res.individualId;
    });
    this.singInService.indivId.subscribe(res => {
      if (res !== "null" && !this.indivId) {
        this.indivId = res;
      }
    });
    userTypeUpdated.subscribe(type => {
      if(type){
        this.userType = type;
      }
    })
    this.isKepro = JSON.parse(sessionStorage.getItem('isKepro'));
    this.defaultLanguage = this.translate.getDefaultLang();
    this.globalLanguage = sessionStorage.getItem('globalTranslatedLan') ? sessionStorage.getItem('globalTranslatedLan') : null;

    let currentUser = null;
    if(sessionStorage.getItem('currentUser')) {
      currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    }
    this.userType = sessionStorage.getItem('userType');
    if (currentUser && currentUser.userId) {
      this.getUserDetails();
    }

    this.userSub = this.singInService.userLoggedIn.subscribe(res => {
      this.isLoggedOut = !res;
      if (res) {
        this.getUserDetails();
      }
    });

    this.activatedRoute.queryParams.subscribe(res => {
      this.entId = res.entityId;
      // Capture usertype from query params for PP FAQ new tab
      if (res.usertype) {
        this.queryUserType = res.usertype;
      }
      this.currentLang = res.lang || this.currentLang;
      sessionStorage.setItem('currentLang', this.currentLang);
    });
    
    const snapshotParams = this.activatedRoute.snapshot.queryParams;
    if (snapshotParams.usertype) {
      this.queryUserType = snapshotParams.usertype;
    }

    // this.tcamId = this.serverConfig.getServerConfig().TCAM_KEY;
    // const payload = { tcam: this.getCookie(this.tcamId), entityId: this.entId };
    // const contentHeader = new HttpHeaders({ "Content-Type": "application/json" });
    // this.apiService.post(`publ/users/partnerLogin`, payload, { headers: contentHeader, observe: 'response' }).subscribe((res: any) => {
    //   if (res && res.body.isValidSession === 'true') {
    //     sessionStorage.setItem('userType', res.body.userType);
    //     sessionStorage.setItem('userName', res.body.userName);
    //     this.pPUserName = sessionStorage.getItem('userName');
    //     const authToken = res.headers.get('x-auth-token');
    //     this.authService.setToken(authToken);

    //     const userName = {
    //       'userName': this.pPUserName
    //     };
    //     if (!isNil(userName.userName)) {
    //       this.apiservice.post('indi/users/manageMyAccount', userName).subscribe((response) => {
    //         this.pPUserDetails = response;
    //       });
    //     }
    //   }
    // })
    this.isMobileView = this.screenWidth <= this.mobileWidth;
    const firstTimeUser = sessionStorage.getItem('firstTimeAccessSw');
    if (firstTimeUser && firstTimeUser === "Y" && this.isMobileView) {
      this.showTutorialInMobileView = true;
    }
  }

  fromPartnerPortal() {
    // For RP users in new tab for FAQ, return true
    const urlParams = new URLSearchParams(window.location.search);
    const queryUserType = this.queryUserType || urlParams.get('usertype');
    
    if (queryUserType === 'RP') {
      return true;
    }
    
    const userType = sessionStorage.getItem('userType');
    const userName = userType === 'RP' ? sessionStorage.getItem('userName') : null;
    return !isNil(userName);
  }

  mobileUser() {
    let mobileUser = sessionStorage.getItem('isMobileUser');
    this.url = this.router.url;
    if(this.url.includes('mobile-errorpage')){
      mobileUser = 'true';
    }
    return mobileUser === 'true' ? true : false;
  }

  isAhsRidpFlow(){
    return sessionStorage.getItem('isAhsRidp') === 'true';
  }

  navigateTo(link: string) {
    this.router.navigateByUrl(link);
    this.createAccountService.setIsStepperOn(false);
    this.dropdownOpened = false;
  }

  navigateToSignIn() {
    // Get query params from the current URL
    const urlTree = this.router.parseUrl(this.router.url);
    const currentQueryParams = urlTree.queryParams;
    
    // Preserve query params if they exist
    if (currentQueryParams?.utm_id && currentQueryParams?.utm_id === 'linkCaseCampaign') {
      this.router.navigate(['/signin'], { 
        queryParams: currentQueryParams
      });
    } else {
      this.router.navigate(['/signin']);
    }
  }

  getUserDetails() {
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        this.userDetails = currentUser;
  }


  onOpen(event) {
    event.preventDefault();
    this.dropdownOpened = !this.dropdownOpened;
    this.hovered = false;
  }
  
  openFAQPopUp() {
    return this.modal.openMobileFAQ();
  }

  navigateToFAQ(event?: Event) {
    if (event) {
      event.preventDefault();
    }
    // Get language to pass via query params
    let lang;
    if(this.awsTranslateSwitch ){
      lang = this.globalLanguage || this.currentLang || 'en';
    }else{
      lang = this.translate.getDefaultLang();
    }
    
    // Open FAQ in new tab with query params
    // The FAQ component will handle setting globalTranslatedLan in session storage
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/faq'], { 
        queryParams: { 
          lang: lang, 
          usertype: this.userType 
        } 
      })
    );
    window.open(url, '_blank');
  }

  onSignout(event) {
    event.preventDefault();
    if (JSON.parse(sessionStorage.getItem('agentRequested'))) {
      this.agentRequested = true;
    }
    let globalLang = sessionStorage.getItem('globalTranslatedLan')
    sessionStorage.clear();
    this.singInService.setGlobalLang(globalLang);
    localStorage.removeItem('ulgTimestamp');
    const tcam = this.getCookie(this.tcamKey);
    if (this.cookieService.check(this.tcamKey)) {
      this.cookieService.delete(this.tcamKey, '/', window.location.hostname)
    }
    sessionStorage.setItem('tcam', tcam);
    this.dropdownOpened = false;
    // Clear CMB navigation data from sessionStorage on signout
    this.userProfileService.clearCmbDataFromSession();
    this.userProfileService.hideRenewal(null);
    this.userProfileService.disableChangeReport.next(null);
    this.userProfileService.enableChangeReport.next(null);
    this.userProfileService.isHoh.next(null);
    this.userProfileService.showHideQFR.next(null);
    this.userProfileService.reconDate.next(null);
    this.userProfileService.isCaseTerminated.next(null);
    this.userProfileService.getKbData.next(null);
    this.userProfileService.dcsOrSSIMultipleCase.next(null);
    this.userProfileService.isCaseDenied.next(null);
    if (ChatbotComponent.chatbotInstance) {
      ChatbotComponent.chatbotInstance.destroy(this.agentRequested);
    }

    this.signout.emit();
  }

  openTranslateWidget(){
    this.modal
    .openTranslateModal();
  }

  setLanguage() {
    this.defaultLanguage = this.translate.getDefaultLang();
    sessionStorage.removeItem('globalTranslatedLan');
    if (this.defaultLanguage === 'en' && this.globalLanguage  === null) {
      this.translate.setDefaultLang('sp');
      this.translate.use('sp');
      this.defaultLanguage = 'sp';
      sessionStorage.setItem('currentLang', 'sp');
      this.cd.markForCheck();
    } else {
      this.translate.setDefaultLang('en');
      this.translate.use('en');
      this.defaultLanguage = 'en';
      sessionStorage.setItem('currentLang', 'en');
      this.cd.markForCheck();
    }
    if(this.globalLanguage  !== null){
     this.globalLanguage = null;
     location.reload();
    }
  }

  removeSignIn(res?) {
    if (res && res === 'false') {
      return this.show = false
    } else {
      return this.show = true;
    }
  };

  isLoggedIn() {
    // For RP users in new tab for FAQ, treat as logged in to hide translate
    const urlParams = new URLSearchParams(window.location.search);
    const queryUserType = this.queryUserType || urlParams.get('usertype');
    
    if (queryUserType === 'RP') {
      return true;
    }
    
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    const userName = sessionStorage.getItem('userName');
    const getCurrentUser = !isNil(currentUser) || !isNil(userName);

    const token = this.authService.tokenId;
    const hasToken = !isNil(token);
    return and(hasToken, getCurrentUser);
  }


  getCookie(name) {
    let cookieArr = document.cookie.split(";");

    for (let i = 0; i < cookieArr.length; i++) {
      let cookiePair = cookieArr[i].split("=");
      if (name == cookiePair[0].trim()) {
        return decodeURIComponent(cookiePair[1]);
      }
    }

    return null;
  }

  toggleProfile() {
    if(!this.mobileUser() && !this.isOnVerifyIdentityPage()){
      this.dropdownOpened = !this.dropdownOpened;
      this.hovered = false;
    } else {
      this.dropdownOpened = false;
      this.hovered = false;
    }
  }

  isOnVerifyIdentityPage(): boolean {
    return this.router.url.includes('verify-identity');
  }

  setLogoRedirectionUrl(): void {
    // Disable navigation if user is on verify-identity page
    if (this.isOnVerifyIdentityPage()) {
      return;
    }

    const currentUrl = this.router.url;
    if(sessionStorage.getItem('appType') === 'APL') {
      const pageId = currentUrl.split('/').pop();
      this.state.canDeactivateAppeal('TNIcon',pageId);
    } else if (sessionStorage.getItem('appType') === 'MEDICAL_APPEAL' && !currentUrl.includes('congrats')) {
      const pageId = currentUrl.split('/').pop();
      this.state.canDeactivateMedicalAppeal('TNIcon',pageId);
    } else {
      const canNavigate = this.isLoggedIn() && !this.fromPartnerPortal() && !this.mobileUser();
      if (canNavigate) {
        this.router.navigateByUrl('/user-profile/benefit-dashboard');
      }
    }
  }

  navigateToManageAccount() {
    const currentUrl = this.router.url;
    if (sessionStorage.getItem('appType') === 'MEDICAL_APPEAL' && !currentUrl.includes('congrats')) {
      const pageId = currentUrl.split('/').pop();
      this.state.canDeactivateMedicalAppeal('manageAccount',pageId);
    } else {
      this.router.navigateByUrl('/user-profile/manage-account');
    }
  }


  decreaseFont(): boolean {
    const globalLang = sessionStorage.getItem('globalTranslatedLan'); 
    const currentLang = sessionStorage.getItem('currentLang');
    return globalLang === 'de' || globalLang === "ru" || globalLang === "am" || globalLang === "fr" || 
            globalLang === "tl" || (globalLang === null && currentLang === 'sp');
  }

  increaseWidth(): boolean {
    const globalLang = sessionStorage.getItem('globalTranslatedLan'); 
    return (globalLang === 'de');
  }

  extraWidth(): boolean {
    const globalLang = sessionStorage.getItem('globalTranslatedLan'); 
    return (globalLang === "ru");
  }

  ngOnDestroy() {
    this.userSub.unsubscribe();
  }
}
